import { Btn } from "AbstractElements";
import { exportVoucher } from "Features/Learning/Vouchers/Utils/VoucherUtils";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Modal, ModalBody, ModalFooter, ModalHeader, Form, FormGroup, Label, Input } from "reactstrap";

const ModalExportVoucher = () => {
  const { id } = useParams()
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.Voucher.isLoading);
  const isExportLoading = useSelector(state => state.Voucher.isExport);
  const [modalOpen, setModalOpen] = useState(false);
  const [status, setStatus] = useState("");

  const toggle = () => setModalOpen(!modalOpen);

  const handleExport = (e) => {
    e.preventDefault();
    status !== "" && dispatch(exportVoucher({ id, status }));
  }

  return (
    <>
      <Btn attrBtn={{ color: 'primary', onClick: toggle, className: "px-2 py-1", disabled: isLoading }}>
        <i className="fa fa-upload fa-lg me-2"></i> Export Kupon
      </Btn>

      <Modal isOpen={modalOpen} toggle={toggle} backdrop="static" centered>
        <ModalHeader toggle={toggle}>Export Kupon</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="status" className="form-label">Status</Label>
              <Input
                type="select"
                id="status"
                name="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                required
              >
                <option value="">Pilih Status</option>
                <option value="pending">Pending</option>
                <option value="paid">Paid</option>
                <option value="cancelled">Cancelled</option>
                <option value="expired">Expired</option>
              </Input>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle }}>Cancel</Btn>
          <Btn attrBtn={{ color: "primary", onClick: handleExport, disabled: isExportLoading }}>Export</Btn>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalExportVoucher;